import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AutoAlignment from './AutoAlignment';
import PositionAlignOverview from './PositionAlignOverview';
import Regressions from './regressions';
export default function Demo() {
    return (_jsxs("div", { children: [_jsx("h1", { children: "react-stick" }), _jsx("p", { children: _jsx("a", { href: "https://github.com/signavio/react-stick", children: "Open documention on Github" }) }), _jsx(PositionAlignOverview, {}), _jsx(AutoAlignment, {}), _jsx(Regressions, {})] }));
}
